import { render, staticRenderFns } from "./AppDown.vue?vue&type=template&id=15a2e8a7&scoped=true&"
import script from "./AppDown.vue?vue&type=script&lang=js&"
export * from "./AppDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2e8a7",
  null
  
)

export default component.exports